import createIcon from '../../createIcon';

/**
 * @component @name SettingsInputHdmi
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggN1Y0QzE4IDIuOSAxNy4xIDIgMTYgMkg4QzYuOSAyIDYgMi45IDYgNFY3SDVWMTNMOCAxOVYyMkgxNlYxOUwxOSAxM1Y3SDE4Wk04IDRIMTZWN0gxNFY1SDEzVjdIMTFWNUgxMFY3SDhWNFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsInputHdmi = createIcon('SettingsInputHdmi', [
  [
    'path',
    {
      d: 'M18 7V4C18 2.9 17.1 2 16 2H8C6.9 2 6 2.9 6 4V7H5V13L8 19V22H16V19L19 13V7H18ZM8 4H16V7H14V5H13V7H11V5H10V7H8V4Z',
      key: '1532k5',
    },
  ],
]);

export default SettingsInputHdmi;
